export enum AccreditedStatus {
  PENDING = 'PENDING',
  SELF_ACCREDITED = 'SELF_ACCREDITED',
  VERIFIED_ACCREDITED = 'VERIFIED_ACCREDITED',
  NOT_ACCREDITED = 'NOT_ACCREDITED',
}
